import { Plane } from "@babylonjs/core/Maths/math.plane";
import { Ray } from "@babylonjs/core/Culling/ray";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { AbstractTool } from "./tools";
import { RoomElement } from './../mdl/RoomElement';
import { WallAddition } from "../mdl/WallAddition";
import { InteractorManager } from "@egr/wcf/modules/core/tool";
import { CoordinatesType } from "@egr/wcf/modules/core/view/View";
import { intersectRayPlane } from "@egr/wcf/modules/core/utils/MathUtils";
export class AbstractRoomTool extends AbstractTool {
    constructor(pRoomManager, pPickPlanePos) {
        super(pRoomManager.app);
        this.mRoomManager = pRoomManager;
        this.mView = null;
        if (this.mPickPlane == null && pPickPlanePos != null) {
            // this.mPickPlane = new Plane(0, pPickPlaneHeight, 0, 0);
            this.mPickPlane = Plane.FromPositionAndNormal(pPickPlanePos.clone(), Vector3.Up());
        }
        else {
            this.mPickPlane = new Plane(0, 1, 0, 0);
        }
        this.mPickPlane3d = new Plane(1, 1, 1, 0);
        this.mInteractorManager = new InteractorManager(this.mApp.viewer);
        this.mInteractorManager.enabled = false;
    }
    start(pParameter) {
        this.mInteractorManager.enabled = true;
        return (super.start(pParameter));
    }
    stop() {
        this.mInteractorManager.clear();
        this.mInteractorManager.enabled = false;
        super.stop();
    }
    /*
    protected getPlanePickPos(pPos: Vector2): Vector3 | null
    {
        let tView = this.mView;
        if (tView == null)
            tView = this.mApp.viewer.hoverView;
        if (tView == null)
            return (null);

        tView.createPickingRayToRef(pPos, CoordinatesType.Client, null, gTmpRay);
        let tPos = intersectRayPlane(gTmpRay, this.mPickPlane);
        return (tPos);
    }
    */
    // tslint:disable-next-line:cyclomatic-complexity
    getPlanePickPos2d(pPos) {
        let tView = this.mView;
        if (tView == null) {
            tView = this.mRoomManager.hoverView;
        }
        if (tView == null) {
            return (null);
        }
        let tRE = null;
        let tSel = this.mRoomManager.app.model.selection;
        if (tSel.length === 1) {
            if (tSel[0] instanceof RoomElement) {
                tRE = tSel[0];
            }
            if (tSel[0] instanceof WallAddition) {
                tRE = tSel[0];
            }
        }
        let tPos;
        if (tRE != null && (tRE instanceof RoomElement) && (tRE.getPickPlane() != null)) {
            if (tRE.type === "BackgroundImage" || tRE.type === "Rectangle" || tRE.type === "Spline" || tRE.type === "Circle" ||
                tRE.type === "Line" || tRE.type === "CameraPath") {
                let tREpickPlane = tRE.getPickPlane();
                tView.createPickingRayToRef(pPos, CoordinatesType.Client, null, gTmpRay);
                tPos = intersectRayPlane(gTmpRay, tREpickPlane);
            }
            else {
                tView.createPickingRayToRef(pPos, CoordinatesType.Client, null, gTmpRay);
                tPos = intersectRayPlane(gTmpRay, this.mPickPlane);
            }
            return (tPos);
        }
        if (tRE != null && (tRE instanceof WallAddition) && (tRE.PickPlane != null)) {
            if (tRE.type === "PictureFrame" && this.mRoomManager.viewMode === 7) {
                let tREpickPlane = tRE.PickPlane;
                if (tREpickPlane != null) {
                    tView.createPickingRayToRef(pPos, CoordinatesType.Client, null, gTmpRay);
                    tPos = intersectRayPlane(gTmpRay, tREpickPlane);
                }
                else {
                    tView.createPickingRayToRef(pPos, CoordinatesType.Client, null, gTmpRay);
                    tPos = intersectRayPlane(gTmpRay, this.mPickPlane);
                }
            }
            else {
                tView.createPickingRayToRef(pPos, CoordinatesType.Client, null, gTmpRay);
                tPos = intersectRayPlane(gTmpRay, this.mPickPlane);
            }
            return (tPos);
        }
        tView.createPickingRayToRef(pPos, CoordinatesType.Client, null, gTmpRay);
        tPos = intersectRayPlane(gTmpRay, this.mPickPlane);
        return (tPos);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    getPlanePickPos2d_Hill(pPos) {
        let tView = this.mView;
        if (tView == null)
            tView = this.mRoomManager.hoverView;
        if (tView == null)
            return (null);
        let tRE = null;
        let tSel = this.mRoomManager.app.model.selection;
        if (tSel.length === 1) {
            if (tSel[0] instanceof RoomElement) {
                tRE = tSel[0];
            }
            if (tSel[0] instanceof WallAddition) {
                tRE = tSel[0];
            }
        }
        let tPos;
        if (tRE != null && (tRE instanceof RoomElement) && (tRE.getPickPlane() != null)) {
            if (tRE.type === "BackgroundImage" || tRE.type === "Rectangle" || tRE.type === "Spline" || tRE.type === "Circle" || tRE.type === "Line") {
                let tREpickPlane = tRE.getPickPlane(true);
                tView.createPickingRayToRef(pPos, CoordinatesType.Client, null, gTmpRay);
                tPos = intersectRayPlane(gTmpRay, tREpickPlane);
            }
            else {
                tView.createPickingRayToRef(pPos, CoordinatesType.Client, null, gTmpRay);
                tPos = intersectRayPlane(gTmpRay, this.mPickPlane);
            }
            return (tPos);
        }
        if (tRE != null && (tRE instanceof WallAddition) && (tRE.PickPlane != null)) {
            if (tRE.type === "PictureFrame" && this.mRoomManager.viewMode === 7) {
                let tREpickPlane = tRE.PickPlane;
                if (tREpickPlane != null) {
                    tView.createPickingRayToRef(pPos, CoordinatesType.Client, null, gTmpRay);
                    tPos = intersectRayPlane(gTmpRay, tREpickPlane);
                }
                else {
                    tView.createPickingRayToRef(pPos, CoordinatesType.Client, null, gTmpRay);
                    tPos = intersectRayPlane(gTmpRay, this.mPickPlane);
                }
            }
            else {
                tView.createPickingRayToRef(pPos, CoordinatesType.Client, null, gTmpRay);
                tPos = intersectRayPlane(gTmpRay, this.mPickPlane);
            }
            return (tPos);
        }
        tView.createPickingRayToRef(pPos, CoordinatesType.Client, null, gTmpRay);
        tPos = intersectRayPlane(gTmpRay, this.mPickPlane);
        return (tPos);
    }
    getPlanePickPos3d(pPos) {
        let tView = this.mView;
        if (tView == null)
            tView = this.mRoomManager.hoverView;
        if (tView == null)
            return (null);
        tView.createPickingRayToRef(pPos, CoordinatesType.Client, null, gTmpRay);
        let tPos = intersectRayPlane(gTmpRay, this.mPickPlane3d);
        return (tPos);
    }
}
//// temp variables ////////////////////////////////////////////////////////////////////////////
let gTmpRay = Ray.Zero();
